module.exports = __webpack_public_path__ + "img/a0309_5.c395ced3.png";